import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Phone, Mail, Instagram, Facebook } from 'lucide-react';
import { businessInfo, logoUrl } from '../data/mock';

const Footer = () => {
  const navigate = useNavigate();

  const scrollToSection = (path, sectionId) => {
    navigate(path);
    setTimeout(() => {
      if (sectionId) {
        const element = document.getElementById(sectionId);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      } else {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    }, 100);
  };

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <div className="footer-logo-container">
              <img src={logoUrl} alt="Joe's Appliance Installs Logo" className="footer-logo-image" />
              <h3 className="footer-brand">{businessInfo.name}</h3>
            </div>
            <p className="footer-tagline">{businessInfo.tagline}</p>
            <p className="footer-text">{businessInfo.serviceArea}</p>
          </div>

          <div className="footer-section">
            <h4 className="footer-heading">Quick Links</h4>
            <ul className="footer-links">
              <li><a href="#" onClick={(e) => { e.preventDefault(); scrollToSection('/', null); }}>Home</a></li>
              <li><a href="#" onClick={(e) => { e.preventDefault(); scrollToSection('/', 'installation-services'); }}>Services</a></li>
              <li><a href="#" onClick={(e) => { e.preventDefault(); scrollToSection('/', 'why-choose'); }}>About</a></li>
              <li><Link to="/contact">Get a Quote</Link></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4 className="footer-heading">Contact</h4>
            <div className="footer-contact">
              <a href={`tel:${businessInfo.phone}`} className="footer-contact-item">
                <Phone size={16} />
                <span>{businessInfo.phone}</span>
              </a>
              <a href={`mailto:${businessInfo.email}`} className="footer-contact-item">
                <Mail size={16} />
                <span>{businessInfo.email}</span>
              </a>
            </div>
            <div className="footer-social">
              <a href={businessInfo.instagram} target="_blank" rel="noopener noreferrer" className="footer-social-icon">
                <Instagram size={20} />
              </a>
              <a href={businessInfo.facebook} target="_blank" rel="noopener noreferrer" className="footer-social-icon">
                <Facebook size={20} />
              </a>
            </div>
          </div>

          <div className="footer-section">
            <h4 className="footer-heading">Credentials</h4>
            <ul className="footer-credentials">
              <li>{businessInfo.insurance}</li>
              <li>{businessInfo.worksafe}</li>
              <li>{businessInfo.gst}</li>
              <li>{businessInfo.experience}</li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <p className="footer-copyright">
            © {new Date().getFullYear()} {businessInfo.name}. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
